import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';
import intlEquipped from '../../../hocs/intlEquipped';

import ConfirmationModal from './ConfirmationModal';

const enhance = compose(
    themr('ConfirmationModal'),
    intlEquipped
);

export default enhance(ConfirmationModal);
